import React from "react";

const DprSummary = ({ dpr, onUpdate }) => {
  const handleBlur = (field, value) => {
    if (value !== dpr[field]) {
      onUpdate({ ...dpr, [field]: value });
    }
  };

  return (
    <section>
      <h3 className="section-eyebrow mb-3">Project status — narrative</h3>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="field">
          <label className="label">Last 24 hours</label>
          <textarea
            defaultValue={dpr.summaryLast24h}
            onBlur={(e) => handleBlur("summaryLast24h", e.target.value)}
            placeholder="Summary of work completed in the last 24 hours…"
            maxLength={2000}
            rows={4}
            className="input resize-y"
          />
        </div>
        <div className="field">
          <label className="label">Next 24 hours</label>
          <textarea
            defaultValue={dpr.summaryNext24h}
            onBlur={(e) => handleBlur("summaryNext24h", e.target.value)}
            placeholder="Planned work for the next 24 hours…"
            maxLength={2000}
            rows={4}
            className="input resize-y"
          />
        </div>
      </div>
    </section>
  );
};

export default DprSummary;
